import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../utils/Api";
import CreateGame from "./popups/createGame"; 
import Loader from "../common/loader";
import { useNavigate } from "react-router-dom";
import {deleteGame} from "../../Services/Games/gamesService" 
import { toast } from 'react-toastify';
const $ = require("jquery");
require("datatables.net");
const Games = ({ data }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);  
  const [type, setType] = useState('CREATE');
  const [reRender, setReRender] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [createGameModal, setCreateGameModal] = useState(false);  
  const [rowData,setRowData]=useState({})
  let createPopupClose=()=>{
    setCreateGameModal(false)
  } 
  
  function isObject(obj) {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
  }
 
  let tablererender=()=>{setReRender(!reRender)}
  useEffect(() => { 
    // Initialize DataTable
    setIsLoading(true)
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/games/getGameDataTable`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`, 
        },
        dataSrc: function (json) { 
          if(json.errorMessage!==undefined && (json.errorMessage==='Permission denied' || json.errorMessage === "Invalid token")){
           localStorage.clear();  
           navigate('/login')
          }else{
           return json.aaData
         } 
        }
        
      },
      columns: [
        { data: "id" },
        {data: "game_name" },  
        { data: "subject_name" },
        { data: "category_name" },
        { data: "grade_name" },
        { data: "status" }, 
        { data: "createdat" }, 
        {
          data: null,
          title: 'Actions&nbsp;&nbsp;&nbsp;',
          render: (data, type, row) => `
              <div class="tooltip-container">
                  <span class="a-edit">
                      <i class="bi bi-pencil-square"></i>
                      <span class="tooltip-text">Edit</span>
                  </span>
              </div>
              <div class="tooltip-container">
                  <span class="a-view">
                      <i class="bi bi-eye-fill"></i>
                      <span class="tooltip-text">View</span>
                  </span>
              </div>
              <div class="tooltip-container">
                  <span class="a-delete">
                      <i class="bi bi-trash-fill"></i>
                      <span class="tooltip-text">Delete</span>
                  </span>
              </div>
          `
        }
      ],
      'columnDefs': [ {
        'targets': [7], /* column index */
        'orderable': false, /* true or false */
     }],
     createdRow: (row, data, dataIndex) => {   
      
      $(row).find('.a-edit').on('click', function(){  
        setCreateGameModal(true)
        setRowData(JSON.stringify(data))  
        setType('EDIT')
      }  
    ); 
    $(row).find('.a-delete').on('click', () => { 
      if(window.confirm('Are you sure you want to delete this game?')){
        deleteGame(data.id)
        .then((response) => {
       if (response?.status===true) {
          toast.success(response?.message)
          setReRender(!reRender)
       }else{
        toast.error(response?.errorMessage)
       }
       })
       .catch((error) => {
       toast.error('Error deleting game:', error);
       });
      }  
      });
      $(row).find('.a-view').on('click', () => {  navigate(`/masters/games/view/${data.id}`) } ); 
    },
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]],
    }); 
    return () => { 
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy(); 
    };
  }, [data,reRender,navigate]);

  
  return (
    <div> 
    <main id="main" className="main">
       <div className="pagetitle">
          <h1>Games</h1>
       </div>
       <section className="section">
          <div className="row">
             <div className="col-lg-12">
                <div className="card p-10">
                      <h5 className="card-title">
                      <button
                        type="button"
                        className="btn btn-primary float-right"                        
                        onClick={()=>{setType('CREATE');setCreateGameModal(true)}}
                        >
                        + Add Game
                        </button>
                      </h5>
                      {isLoading?
                      <Loader />
                      :"" }
                      <div className={isLoading?'card-body hide':'card-body'}>
                      <table
                         className="table table-striped table-hover table-bordered no-footer dataTable"
                         width="100%"
                         ref={tableRef}
                         >
                         <thead>
                            <tr>
                               <th>Game id</th>
                               <th>Game Name</th> 
                               <th>Subject</th>
                               <th>Category</th>
                               <th>Grade</th>
                               <th>Status</th>
                               <th>Created Date</th>
                               <th>Actions</th>
                            </tr>
                         </thead>
                      </table>
                   </div>
                </div>
          </div>
 </div>
 </section>
 </main> 
 {createGameModal ? (
  <CreateGame 
    popupType={type} 
    editdata={!isObject(rowData) ? JSON.parse(rowData) : rowData} 
    tablererender={tablererender} 
    isShow={createGameModal} 
    close={createPopupClose} 
  />
) : ''}

 </div>
  );
};

export default Games;